import React, { lazy, Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { getEditableSteps } from '@carvana/purchase-utils';
import { history } from '@carvana/purchase-store';
import {
  Wrapper,
  Heading,
  SubHeading,
  StyledCloseLarge,
  OrderSummaryWrapper
} from './order-summary.styles';
import { Loading } from '@carvana/purchase-styles';

const OrderSummaryComponent = lazy(() =>
  import(
    /* webpackChunkName: "carvana-purchase-order-summary" */ '@carvana/purchase-order-summary'
  )
);

export class Summary extends PureComponent {
  static propTypes = {
    closeSummary: PropTypes.func.isRequired,
    orderSummary: PropTypes.shape({}).isRequired,
    paymentSummary: PropTypes.shape({}).isRequired,
    GetPaymentSummary: PropTypes.func.isRequired,
    routeTo: PropTypes.func.isRequired,
    experiments: PropTypes.shape({}).isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string
    }).isRequired,
    analytics: PropTypes.shape({
      trackEvent: PropTypes.func
    }).isRequired,
    steps: PropTypes.arrayOf(PropTypes.shape({})),
    isInPurchaseHeaderExperiment: PropTypes.bool.isRequired
  };

  static defaultProps = {
    steps: []
  };

  unlisten = null;

  state = {
    isLoading: false
  };

  async componentDidMount() {
    const { closeSummary, orderSummary, GetPaymentSummary } = this.props;
    this.setState({ isLoading: true });

    if (orderSummary?.paymentMethod?.selectedPromotionalExtensions) {
      delete orderSummary.paymentMethod.selectedPromotionalExtensions;
    }

    await GetPaymentSummary();

    setTimeout(() => {
      this.setState({ isLoading: false });
    }, 500);

    this.unlisten = history.listen(() => {
      closeSummary();
    });
  }

  componentWillUnmount() {
    const { closeSummary } = this.props;
    closeSummary();

    if (this.unlisten) this.unlisten();
  }

  render() {
    const { isLoading } = this.state;
    const {
      routeTo,
      steps,
      orderSummary,
      paymentSummary,
      isInPurchaseHeaderExperiment,
      closeSummary
    } = this.props;

    const handleEditClick = (url, state) => {
      routeTo(url, 'replace', state);
      closeSummary();
    };

    const editableSteps = getEditableSteps(steps);

    return (
      <Wrapper isLoading={isLoading}>
        {isLoading && <Loading />}
        {!isLoading && (
          <Fragment>
            {isInPurchaseHeaderExperiment && (
              <StyledCloseLarge onClick={closeSummary} />
            )}
            <Heading>
              My Purchase Summary
              <SubHeading>
                Please carefully review and confirm your order details below.
                Make all the necessary changes to your selections.
              </SubHeading>
            </Heading>
            <OrderSummaryWrapper>
              <OrderSummaryComponent
                dashboardSummary={orderSummary}
                handleEditClick={handleEditClick}
                editableSteps={editableSteps}
                paymentSummary={paymentSummary}
              />
            </OrderSummaryWrapper>
          </Fragment>
        )}
      </Wrapper>
    );
  }
}

export default Summary;
